import PricepointSVG from "@design-system/ui-icons/vanilla/Pricepoint"
import { createIcon } from "../createIcon"

export const PricepointIcon = createIcon(PricepointSVG)
